import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { FormattedMessage } from 'react-intl'
import noop from 'lodash/noop'

import ProgressiveLoader from '@/checkout-instore-legacy/components/Loader/ProgressiveLoader'
import { StepCalculator } from '@/checkout-instore-legacy/utils/stepUtils'
import { countExternalPayments } from '@/checkout-instore-legacy/utils/PaymentUtils'
import { ORDER_STEPS_LIST } from '../steps'
import Button from '@vtex/styleguide/lib/Button'
import PaymentApp from '@/checkout-instore-legacy/transaction/authorization/challenge/paymentApp/PaymentApp'
import PaymentRedirect from '@/checkout-instore-legacy/transaction/authorization/challenge/redirect/PaymentRedirect'

class PlaceOrder extends Component {
  constructor(props) {
    super(props)
    this.estimatedDuration = null
    this.stepCalculator = new StepCalculator(ORDER_STEPS_LIST)
  }

  handleCancel = () => {
    this.props.cancelOrder()
  }

  render() {
    const {
      step,
      transaction,
      externalPaymentIndex,
      active,
      success,
    } = this.props.order
    const payments =
      transaction && transaction.paymentData && transaction.paymentData.payments

    if (!transaction || !payments || !step) {
      return null
    }

    const externalPaymentsCount = countExternalPayments(payments)

    const previousStepsEstimatedDurationSum = this.stepCalculator.getPreviousStepsDuration(
      step,
      externalPaymentIndex,
      externalPaymentsCount
    )

    if (!this.estimatedDuration) {
      this.estimatedDuration = this.stepCalculator.getEstimatedDuration(
        externalPaymentsCount
      )
    }

    const { paymentApp, redirectUrl } = this.props

    return (
      <div className="flex bg-base flex-column vh-100">
        {paymentApp && (
          <PaymentApp
            appName={paymentApp.appName}
            appProps={paymentApp.appProps}
          />
        )}
        {redirectUrl && <PaymentRedirect redirectUrl={redirectUrl} />}
        <div className="flex flex-auto overflow-auto flex-column justify-center">
          <ProgressiveLoader
            step={step}
            stop={!active}
            previousStepsEstimatedDurationSum={
              previousStepsEstimatedDurationSum
            }
            estimatedDuration={this.estimatedDuration}
          />
          <div className={`flex-none center mt6 ${success && 'o-0'}`}>
            <Button
              id="cancel-place-order"
              variation="danger-tertiary"
              size="large"
              onClick={success ? noop : this.handleCancel}
              className="flex center"
            >
              <FormattedMessage id="cancel" />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

PlaceOrder.propTypes = {
  order: PropTypes.shape({
    step: PropTypes.object,
    stepGroup: PropTypes.string,
    order: PropTypes.object,
    transaction: PropTypes.object,
    success: PropTypes.bool,
    externalPaymentIndex: PropTypes.number,
    active: PropTypes.bool,
  }),
  startOrder: PropTypes.func.isRequired,
  cancelOrder: PropTypes.func.isRequired,
  router: PropTypes.any.isRequired,
  paymentApp: PropTypes.object,
  redirectUrl: PropTypes.string,
}

export default withRouter(PlaceOrder)
